import React from 'react';

const AuthForm = ({ children, onSubmit, className = '' }) => (
  <form onSubmit={onSubmit} className={`space-y-4 ${className}`.trim()} noValidate>
    {children}
  </form>
);

AuthForm.Input = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  className = '',
  id,
  name,
  autoComplete,
}) => (
  <input
    id={id}
    name={name}
    type={type}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    required={required}
    autoComplete={autoComplete}
    className={`w-full p-3 bg-white rounded-xl text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 ${className}`.trim()}
  />
);

AuthForm.Button = ({ children, type = 'submit', disabled = false, className = '', ...rest }) => (
  <button
    type={type}
    disabled={disabled}
    className={`w-full bg-orange-500 text-white py-3 rounded-full font-medium hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`.trim()}
    {...rest}
  >
    {children}
  </button>
);

export default AuthForm;
